<template>
    <div>
        <b-row>
            <b-col v-if="large">
              <h3>{{title}}</h3>
              <slot name="badges"></slot>
            </b-col>
            <b-col v-else>
              {{title}}
              <slot name="badges"></slot>
            </b-col>
            <b-col></b-col>
            <b-col>
                <a :href="contextPath">
                    <b-img right src="~@/assets/images/question-mark.svg" class="context-help-header"/>
                </a>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import Vue from 'vue'
  export default {
    name: 'context-header',
    data () {
      return {
        showLoader: this.show
      }
    },
    computed: {
      contextPath () {
        if (this.alternativeRoute.length > 0) {
          return (Vue.$config.help_root + '/' + this.alternativeRoute + '/' + this.tab).replace(/([^:]\/)\/+/g, '$1')
        }
        return (Vue.$config.help_root + this.$route.path + '/' + this.tab).replace(/([^:]\/)\/+/g, '$1')
      }
    },
    props: {
      title: {
        type: String,
        default: 'default'
      },
      alternativeRoute: {
        type: String,
        default: ''
      },
      tab: {
        type: String,
        default: ''
      },
      large: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" type="text/scss">
  .context-help-header {
      cursor: pointer;
      opacity: 0.7;
      width: 28px;
      height: 28px;
      margin: 0px;
      &:hover {
        opacity: 1.0;
      }
  }
</style>



// WEBPACK FOOTER //
// ContextHeader.vue?8ae08ae4